export const MODAL_Z_INDEX_BASE = 3000;
export const MODAL_Z_INDEX_NESTED = 4000;
export const POPOVER_Z_INDEX = 5000;
